<template>
  <div :id="'page-' + data_page.pageId">
    <div
      v-if="!isStartedLoading"
      style="position: relative"
      class="img-result-center margin-bottom-25"
      :style="{ width: data_page.data_image.width + 'pt', height: data_page.data_image.height + 'pt' }"
    >
      <FAIcon icon="fa fa-spin fa-spinner" />
    </div>
    <PageResult
      v-else
      :document_type="document_type"
      :data_page="data_page"
      :index="index + 1"
      @reload-group="reloadGroup($event)"
      @click-result="handleClickResult($event)"
    />
  </div>
</template>

<script>
import PageResult from './PageResult'
import FAIcon from '@/components/common/FAIcon.vue'

export default {
  name: 'PageResultShowing',
  components: {
    PageResult,
    FAIcon,
  },
  props: {
    data_page: {
      type: Object,
    },
    document_type: {
      type: String,
    },
    index: {
      type: Number,
    },
    isStartedLoading: {
      type: Boolean,
    },
  },
  methods: {
    reloadGroup(reloadData) {
      this.$emit('reload-group', reloadData)
    },
    handleClickResult(index) {
      this.$emit('click-result', index)
    },
  },
}
</script>

<style scoped></style>
